import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { useAssetPageContext, useAssetSortHandler } from './Context'
import { ListViewRow } from './ListViewRow'
import { Table } from '../Table'

const ListViewHeader = () => {
  const { renderAssetStatus } = useAssetPageContext()

  return (
    <thead>
      <tr className="table-secondary">
        <th style={{ width: 60 }}>Image</th>
        <th>Title</th>
        <th style={{ width: '35%' }}>Subtitle</th>
        <ShowIf condition={!!renderAssetStatus}>
          <th style={{ width: 160 }}>Status</th>
        </ShowIf>
        <th style={{ width: 80 }}>Type</th>
        <th style={{ width: 160 }}>Actions</th>
      </tr>
    </thead>
  )
}

export const ListView = () => {
  const { localListAction } = useAssetPageContext()
  const handleSort = useAssetSortHandler()
  const filteredList = localListAction.list

  return (
    <div className="mt-3">
      <Table
        tableClassName="table table-hover  table-bordered table-sm "
        responsive=" "
        dataArray={filteredList}
        head={<ListViewHeader />}
        row={ListViewRow}
        onDragSort={handleSort}
      />
    </div>
  )
}
